import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

import styles from 'features/DefaultHelp.module.css';

const StatusSection = () => {
    return (
        <div>
            <Typography variant="h4">STATUS</Typography>
            <Table className={styles['controls-table']}>
                <TableHead>
                    <TableRow>
                        <TableCell>Status</TableCell>
                        <TableCell>Description</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow>
                        <TableCell>
                            <span>Open</span>
                        </TableCell>
                        <TableCell>Ticket has been submitted and is being worked on.</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>On Hold</span>
                        </TableCell>
                        <TableCell>Action is paused, typically awaiting more info or external response.</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Escalated</span>
                        </TableCell>
                        <TableCell>Ticket is prioritized due to urgency or unresolved delay.</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Closed</span>
                        </TableCell>
                        <TableCell>Ticket has been resolved and finalized.</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

export default StatusSection;
